module.exports = __webpack_public_path__ + "static/media/Andrew Stepner.75f82f08.jpg";